export enum SystemUserInterfaceEnums {
  APP     = 'APP',
  BACKEND = 'BACKEND',
}
